import Admin from "@/views/Admin";
import AdminHome from "@/components/admin-blocks/admin-home";
import notice from '@/components/admin-blocks/admin-notice';
import weChatMaterial from "../components/material-blocks/weChatMaterial";
import newsManager from "../components/material-blocks/newsManager";
import otherMaterial from "../components/material-blocks/otherMaterial";
import templateMessage from "../components/message-blocks/templateMessage";
import helpMessage from "../components/message-blocks/helpMessage";
import usersMessage from "../components/message-blocks/usersMessage";
import weChatMessage from "../components/message-blocks/weChatMessage";
import blindUsers from "../components/users-blocks/blindUsers";
import volunteerUsers from "../components/users-blocks/volunteerUsers";
import totalCount from "../components/count-blocks/totalCount";
import appCount from "../components/count-blocks/appCount";
import volunteerCount from "../components/count-blocks/volunteerCount";
import blindDetail from "../components/users-blocks/blindDetail";
import volunteerDetail from "../components/users-blocks/volunteerDetail";
import helpMessageDetail from "../components/message-blocks/helpMessageDetail";
import publicSetting from "../components/setup-blocks/publicSetting";
import productManager from "../components/material-blocks/productManager";
import webAPP from "../components/app-blocks/webAPP";
import webAppDetail from "../components/app-blocks/webAppDetail";
import editWebAppDetail from "../components/app-blocks/editWebAppDetail";
import editNewsInfo from "../components/material-blocks/editNewsInfo";
import newsInfo from "../components/material-blocks/newsInfo";

export const adminRouter = [
  {
    path: "/admin",
    title: "",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "",
        name: "admin",
        component: AdminHome
      },
      {
        path: "/notice",
        name: "notice",
        title: "通知",
        component: notice
      }
    ]
  },
  {
    path: "/material",
    name: "material",
    title: "素材管理",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/weChatMaterial",
        name: "weChatMaterial",
        title: "微信文章",
        component: weChatMaterial
      },
      {
        path: "/productManager",
        name: "productManager",
        title: "官网产品",
        component: productManager
      },
      {
        path: "/newsManager",
        name: "newsManager",
        title: "官网新闻",
        component: newsManager
      },
      {
        path: "/editNewsInfo",
        name: "editNewsInfo",
        title: "编辑官网新闻",
        component: editNewsInfo
      },
      {
        path: "/newsInfo",
        name: "newsInfo",
        title: "新闻详情",
        component: newsInfo
      },
      {
        path: "/otherMaterial",
        name: "otherMaterial",
        title: "其他",
        component: otherMaterial
      }
    ]
  },
  {
    path: "/appManager",
    name: "appManager",
    title: "APP管理",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/webAPP",
        name: "webAPP",
        title: "官网展示",
        component: webAPP
      },
      {
        path: "/webAppDetail",
        name: "webAppDetail",
        title: "APP详情",
        component: webAppDetail
      },
      {
        path: "/editWebAppDetail",
        name: "editWebAppDetail",
        title: "编辑APP详情",
        component: editWebAppDetail
      }
    ]
  },
  {
    path: "/messageManage",
    name: "messageManage",
    title: "消息管理",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/templateMessage",
        name: "templateMessage",
        title: "模板消息推送",
        component: templateMessage
      },
      {
        path: "/helpMessage",
        name: "helpMessage",
        title: "盲人求助消息",
        component: helpMessage
      },
      {
        path: "/helpMessageDetail",
        name: "helpMessageDetail",
        title: "求助消息详情",
        component: helpMessageDetail
      },
      {
        path: "/usersMessage",
        name: "usersMessage",
        title: "用户反馈消息",
        component: usersMessage
      },
      {
        path: "/weChatMessage",
        name: "weChatMessage",
        title: "微信公共账号消息",
        component: weChatMessage
      }
    ]
  },
  {
    path: "/usersManage",
    name: "usersManage",
    title: "用户管理",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/blindUsers",
        name: "blindUsers",
        title: "盲人用户",
        component: blindUsers
      },
      {
        path: "/blindDetail",
        name: "blindDetail",
        title: "盲人用户详情",
        component: blindDetail
      },
      {
        path: "/volunteerUsers",
        name: "volunteerUsers",
        title: "志愿者用户",
        component: volunteerUsers
      },
      {
        path: "/volunteerDetail",
        name: "volunteerDetail",
        title: "志愿者用户详情",
        component: volunteerDetail
      }
    ]
  },
  {
    path: "/count",
    name: "count",
    title: "统计",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/totalCount",
        name: "totalCount",
        title: "总体数据",
        component: totalCount
      },
      {
        path: "/appCount",
        name: "appCount",
        title: "APP数据",
        component: appCount
      },
      {
        path: "/volunteerCount",
        name: "volunteerCount",
        title: "志愿者数据",
        component: volunteerCount
      }
    ]
  },
  {
    path: "/setup",
    name: "setup",
    title: "设置",
    meta: {requiresAuth: true},
    component: Admin,
    children: [
      {
        path: "/publicSetting",
        name: "publicSetting",
        title: "公众号设置",
        component: publicSetting
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/admin.js